import AcUnitRoundedIcon from '@mui/icons-material/AcUnitRounded';
import { styled } from '@mui/system';
import Tooltip from '@mui/material/Tooltip';

const RootDiv = styled('div')({
  display: 'flex',
  position: 'absolute',
  right: '12px',
  bottom: '12px',
  width: '20px',
  height: '20px',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#2196F31A',
  borderRadius: '50%',
});

export const RefrigeratedIcon = () => {
  return (
    <Tooltip title="Producto refrigerado (2°C - 8°C)">
      <RootDiv>
        <AcUnitRoundedIcon sx={{ fontSize: 16, color: '#0D3C61' }} />
      </RootDiv>
    </Tooltip>
  );
};
